// import {
//   createAsyncThunk,
//   createEntityAdapter,
//   createSlice,
// } from "@reduxjs/toolkit";
// import { enqueueSnackbar } from "notistack";

// import request from "../../utils/request";

// // Create entity adapter
// const myAssessments = createEntityAdapter();

// const initialState = myAssessments.getInitialState({
//   isLoading: false,
//   page: 0,
//   error: null,
//   post_form_data: {},
//   pre_genertated_jds: [],
//   totalAssessments: 0,
//   assessmentsData: {},
// });

// // Async thunk for fetching all posts
// export const getMyAssessments = createAsyncThunk(
//   "my-assessments/getMyAssessments",
//   async (
//     { page = 0, query = "", filter = "", take = 10 },
//     { getState, rejectWithValue }
//   ) => {
//     try {
//       const { auth } = getState();
//       const company_id = auth.user?.company_id;

//       const response = await request({
//         url: "/interview/by-company",
//         method: "POST",
//         data: { company_id: company_id, skip: page, take, query, filter },
//       });

//       console.log("RESPONSE", response, page);

//       return {
//         page,
//         data: response.data?.data,
//         count: response?.data?.count || 0,
//       };
//     } catch (error) {
//       enqueueSnackbar(error?.message, {
//         autoHideDuration: 3000,
//         variant: "error",
//       });
//       return rejectWithValue(error?.message);
//     }
//   }
// );

// // Slice
// const myAssessmentsSlice = createSlice({
//   name: "myAssessments",
//   initialState,
//   extraReducers: (builder) => {
//     builder
//       .addCase(getMyAssessments.pending, (state) => {
//         state.isLoading = true;
//         state.error = null;
//       })
//       .addCase(getMyAssessments.fulfilled, (state, action) => {
//         state.isLoading = false;

//         state.totalAssessments =  action.payload.count > 0 ?  action.payload.count : state?.totalAssessments;
//         myAssessments.upsertMany(state, action.payload.data || []);
//         state.assessmentsData = {
//           ...state.assessmentsData,
//           [action.payload.page]:
//             action.payload.data?.length > 0
//               ? action?.payload?.data?.map((d) => d?.id)
//               : [],
//         };
//       })
//       .addCase(getMyAssessments.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload || action.error.message;
//       })
//   },
// });

// // SELECTORS
// export const {
//   selectAll: selectAllAssessments,
//   selectById: selectAssessmentById,
//   selectIds: selectAssessmentIds,
// } = myAssessments.getSelectors((state) => state.myAssessments);

// export const selectFlattenAssessmentsData = (state) => {
//   return typeof state.myAssessments.assessmentsData === 'object' ? Object.values(state.myAssessments.assessmentsData)?.flat() : [];
// };
// export const selectLoading = (state) => state.myAssessments.isLoading;
// export const selectPage = (state) => state.myAssessments.page;
// export const selectError = (state) => state.myAssessments.error;

// export default myAssessmentsSlice.reducer;
import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";

import request from "../../utils/request";

// Create entity adapter
const myAssessments = createEntityAdapter();

const initialState = myAssessments.getInitialState({
  isLoading: false,
  page: 0,
  error: null,
  post_form_data: {},
  pre_genertated_jds: [],
  totalAssessments: 0,
  assessmentsData: {},
});

// Async thunk for fetching all posts
export const getMyAssessments = createAsyncThunk(
  "my-assessments/getMyAssessments",
  async (
    { page = 0, query = "", filter = "", take = 10, companyId }, // YEH companyId ADD KAREIN
    { getState, rejectWithValue }
  ) => {
    try {
      // YEH LINES COMMENT OUT YA REMOVE KAREIN:
      // const { auth } = getState();
      // const company_id = auth.user?.company_id;

      // YEH LINES ADD KAREIN (posts slice ki tarah):
      const { companies } = getState();
      const company_id = companyId || companies.companies[0]?.id; // fallback ke liye

      const response = await request({
        url: "/interview/by-company",
        method: "POST",
        data: { company_id: company_id, skip: page, take, query, filter },
      });

      console.log("RESPONSE", response, page);

      return {
        page,
        data: response.data?.data,
        count: response?.data?.count || 0,
      };
    } catch (error) {
      enqueueSnackbar(error?.message, {
        autoHideDuration: 3000,
        variant: "error",
      });
      return rejectWithValue(error?.message);
    }
  }
);

// Slice
const myAssessmentsSlice = createSlice({
  name: "myAssessments",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getMyAssessments.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getMyAssessments.fulfilled, (state, action) => {
        state.isLoading = false;

        state.totalAssessments =
          action.payload.count > 0
            ? action.payload.count
            : state?.totalAssessments;
        myAssessments.upsertMany(state, action.payload.data || []);
        state.assessmentsData = {
          ...state.assessmentsData,
          [action.payload.page]:
            action.payload.data?.length > 0
              ? action?.payload?.data?.map((d) => d?.id)
              : [],
        };
      })
      .addCase(getMyAssessments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

// SELECTORS
export const {
  selectAll: selectAllAssessments,
  selectById: selectAssessmentById,
  selectIds: selectAssessmentIds,
} = myAssessments.getSelectors((state) => state.myAssessments);

export const selectFlattenAssessmentsData = (state) => {
  return typeof state.myAssessments.assessmentsData === "object"
    ? Object.values(state.myAssessments.assessmentsData)?.flat()
    : [];
};
export const selectLoading = (state) => state.myAssessments.isLoading;
export const selectPage = (state) => state.myAssessments.page;
export const selectError = (state) => state.myAssessments.error;

export default myAssessmentsSlice.reducer;
